import { useFormik } from "formik"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
//redux
import { useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledTooltip,
  Nav,
  NavItem,
  NavLink,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import { deleteOrder as onDeleteOrder } from "store/actions"
import * as Yup from "yup"
import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import {
  companylist,
  employeelist,
  settingslist,
} from "../../../common/data/settings"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
//import components
import DeleteModal from "../../../components/Common/DeleteModal"
import ManageSettingsTableContainer from "../Components/ManageSettingsTableContainer"
import {
  Companyname,
  Employeename,
  SettingsTitle,
  SettingsValue,
} from "./ManageSettingCol"
import EcommerceOrdersModal from "./ManageSettingsModal"
import "./managesettingstoggle.scss"
import classnames from "classnames"

function ManageSetting() {
  //meta title
  document.title =
    "ManageSettings | TenderSoftware - Flexi TracBoard"

  const [activeTab, setActiveTab] = useState("1")
  const settingList =
    activeTab === "1"
      ? settingslist
      : activeTab === "2"
      ? companylist
      : employeelist

  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  const [manageSettingsList, setmanageSettingsList] = useState(
    activeTab === "1"
      ? settingslist
      : activeTab === "2"
      ? companylist
      : employeelist
  )

  const [order, setOrder] = useState(null)

  useEffect(() => {
    setmanageSettingsList(
      activeTab === "1"
        ? settingslist
        : activeTab === "2"
        ? companylist
        : employeelist
    )
  }, [activeTab])

  const rowClick = () => {}

  const columns = React.useMemo(() => {
    const result = [
      {
        Header: "Settings",
        accessor: "settingtitle",
        filterable: true,
        Cell: cellProps => {
          return <SettingsTitle {...cellProps} />
        },
      },
      {
        Header: "Settings Value",
        accessor: "settingsvalue",
        filterable: true,
        Cell: cellProps => {
          return <SettingsValue {...cellProps} />
        },
      },
      {
        Header: "Action",
        disableFilters: true,
        isDummyField: true,

        Cell: cellProps => {
          return (
            <div
              onClick={e => {
                console.log("Stop Propagation ")
                e.stopPropagation()
              }}
            >
              <UncontrolledDropdown>
                <DropdownToggle href="#" className="card-drop pointer" tag="a">
                  <i className="mdi mdi-dots-horizontal font-size-18" />
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  <div className="">
                    <div className="py-2 px-3">
                      <Link
                        to="#"
                        className="text-muted"
                        onClick={e => {
                          const orderData = cellProps.row.original
                          handleOrderClick(orderData)
                        }}
                      >
                        <i
                          className="mdi mdi-pencil font-size-18 me-2"
                          id="edittooltip"
                        />
                        Edit
                      </Link>
                    </div>
                    {/* <div className="py-2 px-3">
                      <Link
                        to="#"
                        className="text-muted"
                        onClick={e => {
                          e.stopPropagation()
                          const orderData = cellProps.row.original
                          onClickDelete(orderData)
                        }}
                      >
                        <i
                          className="mdi mdi-delete font-size-16 me-2"
                          id="deletetooltip"
                        />
                        Disable
                      </Link>
                    </div> */}
                  </div>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          )
        },
      },
    ]

    if (activeTab === "2") {
      result.unshift({
        Header: "Company",
        accessor: "companyname",
        filterable: true,
        Cell: cellProps => {
          return <Companyname {...cellProps} />
        },
      })
    } else if (activeTab === "3") {
      result.unshift({
        Header: "Employee",
        accessor: "employeename",
        filterable: true,
        Cell: cellProps => {
          return <Employeename {...cellProps} />
        },
      })
    }

    return result
  }, [activeTab])

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: (order && order?.name) || "",
      title: (order && order?.title) || "",
      settingsvalue: (order && order?.settingsvalue) || "",
    },

    validationSchema: Yup.object({
      name:
        activeTab !== 1 && activeTab === "2"
          ? Yup.string().required("Please Enter your Company Name")
          : activeTab !== 1 && activeTab === "3"
          ? Yup.string().required("Please Enter your Employee Name")
          : null,
      title: Yup.string().required("Please Enter your Settings Name"),
      settingsvalue: Yup.string().required("Please Enter your Settings Value"),
    }),

    onSubmit: values => {
      if (isEdit) {
        validation.resetForm()
      } else {
        var newSettings
        if (activeTab === "1") {
          newSettings = {
            id: 1,
            settingtitle: "Alert",
            settingsvalue: "5 minutes",
          }
          settingslist.push(newSettings)
          setmanageSettingsList(settingslist)
        } else if (activeTab === "2") {
          newSettings = {
            id: 1,
            companyname: "Mecondan Groups",
            settingtitle: "Alert",
            settingsvalue: "5 minutes",
          }
          companylist.push(newSettings)
          //setmanageSettingsList(companylist)
        } else if (activeTab === "3") {
          newSettings = {
            id: 1,
            employeename: "Mecondan Groups",
            settingtitle: "Alert",
            settingsvalue: "5 minutes",
          }

          employeelist.push(newSettings)
          // setmanageSettingsList(employeelist)
        }

        console.log("company list ", companylist)
        console.log("newOrder", newSettings)
        // save new order
        // manageSettingsList.push(newSettings)
        validation.resetForm()
      }
      toggle()
    },
  })

  const toggleViewModal = () => setModal1(!modal1)
  const dispatch = useDispatch()

  // useEffect(() => {
  //   setmanageSettingsList(manageSettingsList)
  // }, [manageSettingsList])

  // useEffect(() => {
  //   if (!isEmpty(manageSettingsList) && !!isEdit) {
  //     setmanageSettingsList(manageSettingsList)
  //     setIsEdit(false)
  //   }
  // }, [manageSettingsList])

  const toggle = () => {
    if (modal) {
      setModal(false)
      setOrder(null)
    } else {
      setModal(true)
    }
  }

  const handleOrderClick = arg => {
    const order = arg
    if (order !== null) {
      setOrder({
        id: order.id,
        name: activeTab === "2" ? order?.companyname : order?.employeename,
        title: order.settingtitle,
        settingsvalue: order.settingsvalue,
      })
      setIsEdit(true)
    } else {
      validation.resetForm()
      setIsEdit(false)
    }
    toggle()
  }

  //delete order
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = order => {
    setOrder(order)
    setDeleteModal(true)
  }

  const handleDeleteOrder = () => {
    if (order.id) {
      dispatch(onDeleteOrder(order))
      setDeleteModal(false)
    }
  }
  const handleOrderClicks = () => {
    setmanageSettingsList("")
    toggle()
  }

  return (

    <React.Fragment>
      <EcommerceOrdersModal isOpen={modal1} toggle={toggleViewModal} />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteOrder}
        onCloseClick={() => setDeleteModal(false)}/>
        
      <div className="page-content" id="manage-settings">
        <div className="container-fluid">
      
          <Breadcrumbs
            title={"Manage Settings"}
            breadcrumbItem={"Manage Settings"}/>
            
          <Row className="mb-4">
            <Col sm="12" className="d-flex justify-content-end">
              <div className="text-sm-end">
                <div className="d-flex text-sm-end">
                  <Row className="navtab-main mx-4">
                    <Nav
                      pills
                      className="navtab-bg nav-justified p-0 bg-primary bg-opacity-75">
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={activeTab === "1" ? "bg-primary" : ""}
                          onClick={() => {
                            toggleTab("1")
                          }}>
                          Admin
                        </NavLink>
                      </NavItem>

                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={activeTab === "2" ? "bg-primary" : ""}
                          onClick={() => {
                            toggleTab("2")
                          }}>
                          Company
                        </NavLink>
                      </NavItem>

                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={activeTab === "3" ? "bg-primary" : ""}
                          onClick={() => {
                            toggleTab("3")
                          }}>
                          Employee
                        </NavLink>
                      </NavItem>

                    </Nav>
                  </Row>

                  <div>
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        handleOrderClick(null)
                      }}
                    >
                      Add New
                    </button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <ManageSettingsTableContainer
                    columns={columns}
                    data={manageSettingsList}
                    isGlobalFilter={false}
                    isAddOptions={true}
                    handleOrderClick={handleOrderClick}
                    customPageSize={15}
                    issetting={true}
                    className="custom-header-css"
                    activeTab={activeTab}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {isEdit
                ? activeTab === "1"
                  ? "Admin Settings"
                  : activeTab === "2"
                  ? "Company Settings"
                  : "Employee Settings"
                : activeTab === "1"
                ? "Add Admin Settings"
                : activeTab === "2"
                ? "Add Company Settings"
                : "Add Employee Settings"}
            </ModalHeader>

            <ModalBody>
              <Form
                onSubmit={e => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
                <Row form>
                  <Col className="col-12">
                    {activeTab === "2" && (
                      <div className="mb-3">
                        <Label className="form-label">Company Name</Label>
                        <Input
                          name="name"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.name || ""}
                          invalid={
                            validation.touched.name && validation.errors.name
                              ? true
                              : false
                          }
                        />
                        {validation.touched.name && validation.errors.name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.name}
                          </FormFeedback>
                        ) : null}
                      </div>
                    )}

                    {activeTab === "3" && (
                      <div className="mb-3">
                        <Label className="form-label">Employee Name</Label>
                        <Input
                          name="name"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.name || ""}
                          invalid={
                            validation.touched.name && validation.errors.name
                              ? true
                              : false
                          }
                        />
                        {validation.touched.name && validation.errors.name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.name}
                          </FormFeedback>
                        ) : null}
                      </div>
                    )}

                    <div className="mb-3">
                      <Label className="form-label">Settings</Label>
                      <Input
                        name="title"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.title || ""}
                        invalid={
                          validation.touched.title && validation.errors.title
                            ? true
                            : false
                        }
                      />
                      {validation.touched.title && validation.errors.title ? (
                        <FormFeedback type="invalid">
                          {validation.errors.title}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="form-label">Value</Label>
                      <Input
                        name="settingsvalue"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.settingsvalue || ""}
                        invalid={
                          validation.touched.settingsvalue &&
                          validation.errors.settingsvalue
                            ? true
                            : false
                        }
                      />
                      {validation.touched.settingsvalue &&
                      validation.errors.settingsvalue ? (
                        <FormFeedback type="invalid">
                          {validation.errors.settingsvalue}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      <button
                        type="submit"
                        className="btn btn-primary save-user"
                      >
                        Save
                      </button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}

ManageSetting.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default ManageSetting
